import InputField, {
    InputNumberField,
    SelectOption,
    addOption
} from '../../../../../utils/InputField';
import { TextCapitalize } from '../../../../../utils/TextFormatter';

function AddLifetimeType({ formData, handleChange, update = false }) {
    return (
        <div className="flex flex-col gap-y-3 mb-4">
            {update ? (
                <InputField
                    label="Currency"
                    name="Currency"
                    formData={formData}
                    onChange={handleChange}
                    disabled
                    required
                />
            ) : (
                <SelectOption
                    label="Currency"
                    name="Currency"
                    formData={formData}
                    onChange={handleChange}
                    options={['thb', 'usd', 'eur', 'bdt']?.map((item) =>
                        addOption(item, item?.toUpperCase(), item)
                    )}
                    required
                />
            )}
            <InputNumberField
                label="Duration"
                name="Duration"
                placeholder="Type Duration..."
                formData={{ Duration: 'Lifetime' }}
                onChange={() => {}}
                readOnly
                required
            />
            <div className="flex gap-x-3">
                <InputNumberField
                    label="Amount"
                    name="Amount"
                    placeholder="Type Amount..."
                    formData={formData}
                    onChange={handleChange}
                    required
                />

                <InputNumberField
                    label="Vat(%)"
                    name="VatPercent"
                    placeholder="Type Vat(%)..."
                    formData={formData}
                    onChange={handleChange}
                />
            </div>

            {update && (
                <SelectOption
                    label="Status"
                    name="Status"
                    formData={formData}
                    onChange={handleChange}
                    options={['active', 'inactive']?.map((item) =>
                        addOption(item, TextCapitalize(item), item)
                    )}
                />
            )}
        </div>
    );
}

export default AddLifetimeType;
